import { format } from 'owa-localize';

import { trace } from 'owa-trace';
import createAbbreviatedDurationFormatter from 'owa-duration-formatter/lib/abbreviated';
import {
    formatWeekDayDate,
    formatWeekDayDateTime,
    formatUserDate,
    formatUserTime,
    formatWeekDayMonthDayYear,
    formatMonthDayShortTime,
    formatShortMonthDayYear,
    OwaDate,
} from 'owa-datetime';
import TxpStringFormatters from 'txp-data/lib/schema/configSchema/TxpStringFormatters';
import parseTxpEventDate from './parseTxpEventDate';

// Create formatters for TXP
export default function createTxpStringFormatters(): TxpStringFormatters {
    return {
        format: format,
        durationFormatter: createAbbreviatedDurationFormatter,
        formatUserTime: formatTxpUserTime,
        formatUserDate: formatTxpUserDate,
        formatWeekDayDate: formatTxpWeekDayDate,
        formatWeekDayDateTime: formatTxpWeekDayDateTime,
        formatWeekDayMonthDayYear: formatTxpWeekDayMonthDayYear,
        formatMonthDayShortTime: formatTxpMonthDayShortTime,
        formatShortMonthDayYear: formatTxpShortMonthDayYear,
    };
}

export function formatTxpDateTime(date: string, dateFunction: (date: OwaDate) => string): string {
    if (!date) {
        trace.error('[TXP] formatTxpDateTime: date is null or undefined');
        return '';
    }

    const displayDate = parseTxpEventDate(date);

    return dateFunction(displayDate);
}

function formatTxpUserDate(date: string): string {
    return formatTxpDateTime(date, formatUserDate);
}

function formatTxpUserTime(date: string): string {
    return formatTxpDateTime(date, formatUserTime);
}

function formatTxpWeekDayDate(date: string): string {
    return formatTxpDateTime(date, formatWeekDayDate);
}

function formatTxpWeekDayDateTime(date: string): string {
    return formatTxpDateTime(date, formatWeekDayDateTime);
}

function formatTxpWeekDayMonthDayYear(date: string): string {
    return formatTxpDateTime(date, formatWeekDayMonthDayYear);
}

function formatTxpMonthDayShortTime(date: string): string {
    return formatTxpDateTime(date, formatMonthDayShortTime);
}

function formatTxpShortMonthDayYear(date: string): string {
    return formatTxpDateTime(date, formatShortMonthDayYear);
}
